import React, { useState } from 'react';
import API from '../../../redux/actions/API';
import { APPLY_COUPON_URL } from '../../../utils/APIEndpoints';
import { authHeader } from '../../../utils/functions/CoreFunctions';
import {
  getAlertToast,
  getCurrentAgencyId,
} from '../../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import {
  Form,
  Button,
  Col,
  Input,
  Modal,
  ModalHeader,
  Row,
  FormFeedback,
  FormGroup,
} from 'reactstrap';
import CustomLoader from '../../common/CustomLoader';
import * as Yup from 'yup';
import { useFormik } from 'formik';

const validationSchema = Yup.object({
  couponCode: Yup.string().required('Coupon code is Required'),
});
export default function ApplyCouponModal(props) {
  const { modalFlag, modalToggle, callBack } = props;

  const [loading, setLoading] = useState(false);

  //Apply Coupon
  const applyCoupon = async (values) => {
    setLoading(true);
    try {
      const options = {
        method: 'GET',
        url: APPLY_COUPON_URL,
        headers: authHeader(),
        params: {
          couponCode: values.couponCode,
          agencyId: getCurrentAgencyId(),
        },
      };
      const response = await API(options);
      const { status, data } = response.data;
      if (status === 'Success') {
        Swal.fire(getAlertToast('success', 'Coupon Applied Succesfully'));
        callBack(data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast('error', data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const { handleChange, values, handleSubmit, errors, touched } = useFormik({
    initialValues: {
      couponCode: '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      applyCoupon(values);
    },
  });

  const { couponCode = '' } = values;

  return (
    <Modal centered isOpen={modalFlag} toggle={modalToggle}>
      <ModalHeader toggle={modalToggle}>Apply a Coupon</ModalHeader>
      <div style={{ margin: '10px' }}>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={9}>
              <FormGroup>
                <Input
                  type="text"
                  name="couponCode"
                  id="couponCode"
                  onChange={handleChange}
                  value={couponCode}
                  placeholder="Enter Coupon Code"
                  invalid={
                    errors.couponCode && touched.couponCode ? true : false
                  }
                />
                <FormFeedback>
                  {errors.couponCode && touched.couponCode
                    ? errors.couponCode
                    : ''}
                </FormFeedback>
              </FormGroup>
            </Col>
            <Col md={3}>
              <Button type="submit" style={{ marginTop: '5px' }}>
                {loading && <CustomLoader loading={loading} />}Apply
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
}
